import 'css-chunksrc/client/pages/projectPage/timeSheetPage/allocations/styles.scss';export default {
  "allocations": "_allocations_1yrub_1",
  "allocation": "_allocation_1yrub_1",
  "even": "_even_1yrub_9"
};